import React from 'react';
import { Col, Row } from 'components/Core/Grid';
import Link from '../Link';

import { ProductsMenuContainer } from './styles';

const ProductsMenu = ({ dropdownItems }) => {
  const groups = Array.from(new Set(dropdownItems.map((i) => i?.group?.group))).sort();
  const groupedItems = groups.map((group) =>
    dropdownItems.filter((x) => x?.group?.group === group),
  );
  const titles = [
    'Explore our products',
    <>
      Get more with <span>Pro</span>
    </>,
  ];

  return (
    <ProductsMenuContainer>
      <Row columnSpacing={4}>
        {groupedItems?.map((group, parentIndex) => (
          <Col xs={12} className="simple-nav-col" key={parentIndex}>
            <h6 className="group-title" data-testid="group-title" key={parentIndex}>
              {titles[parentIndex]}
            </h6>
            {group.map((item, index) => (
              <Link
                item={item}
                key={`link-${parentIndex}-${index}`}
                data-testid="product-nav-link"
              />
            ))}
          </Col>
        ))}
      </Row>
    </ProductsMenuContainer>
  );
};

export default ProductsMenu;
